// Mensagens de validação (Zod). Consolidação consciente: o código legado tinha
// variantes SEM acento ('Nome e obrigatorio', 'Data e obrigatoria', 'Descricao e
// obrigatoria', 'proxima'...) — aqui a forma correta acentuada é a canônica, já
// que a semântica é a mesma. Resolvidas via i18n.t('validation:...') dentro das
// factories de lib/validations.ts.
export const validation = {
    required: {
        name: 'Nome é obrigatório',
        date: 'Data é obrigatória',
        description: 'Descrição é obrigatória',
        startDate: 'Data de início é obrigatória',
        amount: 'Valor é obrigatório',
    },
    amount: {
        positive: 'Valor deve ser maior que zero',
        monthlyPositive: 'Valor mensal deve ser maior que zero',
        installmentPositive: 'Valor da parcela deve ser maior que zero',
    },
    select: {
        account: 'Selecione uma conta',
        category: 'Selecione uma categoria',
        card: 'Selecione um cartão',
        destinationAccount: 'Selecione a conta destino',
        paymentAccount: 'Selecione a conta de pagamento',
    },
    installments: {
        min: 'Mínimo 2 parcelas',
        max: 'Máximo 48 parcelas',
    },
    creditCard: {
        limitPositive: 'Limite deve ser positivo',
    },
    budget: {
        name: 'Dê um nome ao orçamento',
        selectCategory: 'Selecione ao menos uma categoria',
    },
    goal: {
        target: 'Valor-alvo é obrigatório',
        targetForMeta: 'Valor-alvo é obrigatório pra uma meta',
    },
    reserva: {
        selectAccount: 'Escolha a conta da caixinha',
    },
    financing: {
        totalInstallments: 'Informe o total de parcelas',
        nextInstallment: 'Informe a próxima parcela',
        nextDueDate: 'Data do próximo vencimento é obrigatória',
        outstandingPositive: 'Saldo devedor deve ser positivo',
        nextGtTotal: 'A próxima parcela não pode ser maior que o total',
        contractName: 'Informe o nome do contrato',
        rateRequiredForSac: 'Informe a taxa do contrato (ao ano) para usar parcela decrescente',
        balanceRequiredForSac: 'Informe o saldo devedor para calcular a parcela decrescente',
        rateTooHigh: 'Taxa do contrato é ao ano, no máximo 100 — confira o separador decimal',
    },
    prepayment: {
        amountPositive: 'Valor do abatimento deve ser maior que zero',
        remainingNonNegative: 'Parcelas restantes deve ser zero ou mais',
        newMonthlyNonNegative: 'Valor da parcela deve ser zero ou mais',
        newOutstandingNonNegative: 'Saldo devedor deve ser zero ou mais',
        remainingRequired: 'Informe quantas parcelas restam após o abatimento',
        newMonthlyRequired: 'Informe o novo valor da parcela',
    },
};
